import SvgRectangle from "./rectangle";

export default SvgRectangle;